// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%280,0,0,0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.navbar {
  background-color: #f8f8f8;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  position: fixed;
  top: 0;
  left: 0;
  bottom:0;
  width: 100%;
  z-index: 100;
}



.navbar-toggler {
  border: none;
}

.navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.navbar-nav {
  margin-left: auto;
}

.navbar-nav .nav-item {
  margin: 0 0.5rem 0 0;
}

.navbar-nav .nav-link {
  color: #281c1c;
  font-weight: bold;
  transition: color 0.2s ease-in-out;
}


.logged-in {
  color: green;
  font-size: small;
  font-style: italic;
  margin-top: 0px;
  margin-bottom: 0px;
}
.navbar-nav .nav-link:hover {
  color: #5e5e5e;
}
.nav-item
{
    color: aliceblue;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/navbar.css"],"names":[],"mappings":";;;;AAIA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,YAAY;AACd;;AAEA;EACE,yDAAqP;AACvP;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;IAEI,gBAAgB;AACpB","sourcesContent":["\n\n\n\n.navbar {\n  background-color: #f8f8f8;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom:0;\n  width: 100%;\n  z-index: 100;\n}\n\n\n\n.navbar-toggler {\n  border: none;\n}\n\n.navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0,0,0,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-nav {\n  margin-left: auto;\n}\n\n.navbar-nav .nav-item {\n  margin: 0 0.5rem 0 0;\n}\n\n.navbar-nav .nav-link {\n  color: #281c1c;\n  font-weight: bold;\n  transition: color 0.2s ease-in-out;\n}\n\n\n.logged-in {\n  color: green;\n  font-size: small;\n  font-style: italic;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.navbar-nav .nav-link:hover {\n  color: #5e5e5e;\n}\n.nav-item\n{\n    color: aliceblue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
